import { HTMLAttributes } from 'react';

import { Editor } from '../../editor';
import { Attribute } from './attribute';
import { FieldWrapper } from './field-wrapper';

interface FormRenderEditorProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  attribute: Attribute;
}

export function FormRenderEditor({ className, attribute }: FormRenderEditorProps) {
  return (
    <FieldWrapper className={className} {...attribute}>
      <Editor
        content={attribute?.editor?.content}
        disabled={attribute?.editor?.disabled}
        ext={attribute?.editor?.ext}
        id={attribute?.id}
        isLoading={attribute?.isLoading}
        mediaPicker={attribute?.editor?.mediaPicker}
        ref={attribute?.editor?.ref}
      />
    </FieldWrapper>
  );
}
